
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Destinationweddingnearwashim() {



  const cardData =
  {
    keyword: ' Destination Wedding Near Washim',
    heading:  'Woodland Escape: Destination Wedding Near Washim ',
    headingDescription: 'Woodland Escape Resort is a dreamy destination wedding resort near Washim, offering lush forest-edged grounds, expansive lawns and tranquil open spaces that create the perfect setting for every wedding event — from engagement and mehendi to the grand ceremony and reception. With generous guest accommodations, versatile indoor-outdoor venues and a dedicated events team handling everything from décor and catering to guest comfort, the resort ensures a seamless and elegant celebration. Couples and their families will appreciate the blend of rustic-chic ambience, cozy cottages and photo-worthy natural backdrops that make for lifelong memories. Whether you plan an intimate affair or a lavish festive wedding, Woodland Escape Resort near Washim provides the ideal mix of luxury, serenity and nature-infused charm to make your special day truly magical.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Destination Wedding Near Washim",
      "description": "Plan a luxurious destination wedding near Washim at serene and scenic locations that offer the perfect backdrop for your special day. These venues combine lush landscapes, elegant décor, and professional services to create a truly memorable wedding experience for you and your guests."
    },
    {
      "name": "Washim Wedding Venue",
      "description": "Choose from top wedding venues in Washim featuring spacious banquet halls, beautiful gardens, and rooftop options. Each venue provides exceptional catering, event planning support, and comfortable accommodations for a flawless celebration."
    },
    {
      "name": "Washim Luxury Wedding Location",
      "description": "Celebrate your wedding in style at Washim’s luxury wedding locations, offering exquisite interiors, premium amenities, and personalized services. Enjoy exclusive wedding experiences with attention to every detail, from decoration to gourmet cuisine."
    },
    {
      "name": "Affordable Wedding Spot Washim",
      "description": "Discover budget-friendly wedding spots in Washim that do not compromise on elegance or services. Perfect for couples looking for a memorable celebration with cost-effective packages, complete with catering, décor, and guest accommodations."
    },
    {
      "name": "Washim Pre Wedding Shoot Location",
      "description": "Capture your love story at scenic pre-wedding shoot locations in Washim. From riverside views to lush gardens and hills, these spots provide romantic and picturesque backdrops to create timeless memories through photography."
    },
    {
      "name": "Washim Outdoor Wedding Spot",
      "description": "Host an enchanting outdoor wedding in Washim surrounded by nature. Enjoy open-air ceremonies, floral décor, and stunning sunset views, creating an unforgettable celebration in a relaxed and natural setting."
    },
    {
      "name": "Washim Riverside Wedding Venue",
      "description": "Celebrate your special day beside tranquil riverside venues in Washim. These spots offer soothing water views, elegant arrangements, and outdoor seating, perfect for romantic ceremonies and lively receptions alike."
    },
    {
      "name": "Washim Hill Wedding Location",
      "description": "Choose hilltop wedding locations in Washim for breathtaking panoramic views, cool breezes, and a serene ambiance. Ideal for couples seeking an intimate and picturesque wedding experience surrounded by nature."
    },
    {
      "name": "Washim Family Wedding Resort",
      "description": "Plan a family-focused wedding at Washim resorts with facilities that cater to all age groups. Enjoy spacious rooms, kid-friendly amenities, and recreational activities, ensuring a comfortable and joyful experience for every guest."
    },
    {
      "name": "Washim Resort Wedding Packages",
      "description": "Select from curated wedding packages at Washim resorts, including venue booking, catering, decoration, and entertainment. These packages make planning seamless while offering a comprehensive and memorable wedding experience."
    },
    {
      "name": "Washim Wedding Booking Online",
      "description": "Easily book your preferred wedding venue online in Washim. Secure your date, select packages, and manage guest arrangements with convenience, ensuring a smooth planning process from start to finish."
    },
    {
      "name": "Washim Wedding Hall",
      "description": "Host your wedding in elegant halls in Washim designed for large gatherings. With modern interiors, professional staff, and customizable layouts, these halls provide a perfect setting for both traditional and contemporary ceremonies."
    },
    {
      "name": "Washim Marriage Destination",
      "description": "Choose Washim as your ultimate marriage destination with venues offering scenic surroundings, luxurious accommodations, and top-notch hospitality. Ideal for couples looking to celebrate their wedding in a peaceful and memorable environment."
    },
    {
      "name": "Washim Resort for Wedding",
      "description": "Plan your dream wedding at Washim resorts offering comprehensive services including accommodation, catering, décor, and event management. These resorts ensure a comfortable and memorable experience for both the couple and their guests."
    },
    {
      "name": "Washim Wedding Destination Packages",
      "description": "Explore all-inclusive wedding destination packages in Washim that cover venue, décor, catering, entertainment, and photography. Perfect for couples looking for a hassle-free wedding planning experience with everything taken care of."
    }
  ],
  "tableData": [
    ["- Destination Wedding Near Washim", "- Washim Wedding Venue"],
    ["- Washim Luxury Wedding Location", "- Affordable Wedding Spot Washim"],
    ["- Washim Pre Wedding Shoot Location", "- Washim Outdoor Wedding Spot"],
    ["- Washim Riverside Wedding Venue", "- Washim Hill Wedding Location"],
    ["- Washim Family Wedding Resort", "- Washim Resort Wedding Packages"],
    ["- Washim Wedding Booking Online", "- Washim Wedding Hall"],
    ["- Washim Marriage Destination", "- Washim Resort for Wedding"],
    ["- Washim Wedding Destination Packages", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Destination Wedding Resort Near Washim",
    "WhyChoosedescription": "Woodland Escape Resort offers an enchanting venue for destination weddings near Washim. With its lush green landscapes, elegant open‑spaces and tranquil surroundings, it sets the scene for a beautifully memorable celebration of your love."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Wedding Locations",
    "WhyChoosedescription": "Imagine exchanging vows beneath wide‑open skies, surrounded by natural foliage and scenic vistas. Woodland Escape Resort’s well‑maintained lawns and garden settings provide an idyllic backdrop for your ceremony, photography and evening festivities."
  },
  {
    "WhyChooseheading": "Spacious Event & Banquet Areas",
    "WhyChoosedescription": "The resort features expansive outdoor lawns and flexible event zones designed to accommodate both intimate gatherings and grand wedding functions. Whether you’re planning a quiet ceremony or a multi‑day celebration, the space adapts to your vision."
  },
  {
    "WhyChooseheading": "Stay & Comfort for Your Guests",
    "WhyChoosedescription": "With comfortable accommodations available onsite (or nearby), Woodland Escape Resort ensures your guests can stay close and enjoy every part of the celebration without worrying about travel. Convenience meets comfort for all your invitees."
  },
  {
    "WhyChooseheading": "Customised Wedding Planning Support",
    "WhyChoosedescription": "From décor and lighting to catering and logistics, the resort team supports the planning and execution of your event. This means less stress for you and more focus on enjoying the moment while everything gets handled seamlessly."
  },
  {
    "WhyChooseheading": "Delightful Catering & Multi‑Cuisine Options",
    "WhyChoosedescription": "Treat your guests to a culinary experience that complements the grandeur of the occasion. Woodland Escape Resort offers freshly‑prepared local and multi‑cuisine menus, ensuring your wedding meals are as memorable as the venue itself."
  },
  {
    "WhyChooseheading": "Romantic & Tranquil Natural Ambience",
    "WhyChoosedescription": "Surrounded by nature, the resort’s peaceful ambiance enhances the romantic feel of a destination wedding. The calming greenery, gentle breeze and open skies work together to provide a special atmosphere for your big day."
  },
  {
    "WhyChooseheading": "Easily Accessible from Washim",
    "WhyChoosedescription": "Located within easy reach of Washim, Woodland Escape Resort offers a blend of accessibility and seclusion—ideal for couples who want a destination‑feel without extremely long travel for their guests."
  }
]






















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a destination wedding venue near Washim?",
    answer: "Woodland Escape Resort offers a beautiful, serene setting for a destination wedding near Washim—lush lawns, natural surroundings, and an environment where you can celebrate in style while your guests stay comfortably."
  },
  {
    question: "How far is Woodland Escape Resort from Washim city?",
    answer: "The resort is conveniently located within driving distance of Washim, making it an accessible yet peaceful destination for your wedding events."
  },
  {
    question: "What wedding facilities does Woodland Escape Resort provide?",
    answer: "The resort offers spacious outdoor lawns, indoor banquet/celebration spaces, catering and décor flexibility, guest accommodation, and dedicated areas for ceremonies, sangeet, mehendi and reception."
  },
  {
    question: "Can Woodland Escape Resort host pre‑wedding and multi‑day wedding events?",
    answer: "Yes. The resort is well suited for pre‑wedding functions, wedding ceremony, and post‑wedding gatherings or brunches, all within one location—so guests don’t have to move around much."
  },
  {
    question: "Does the resort provide catering, accommodation and event coordination for weddings?",
    answer: "Yes. Woodland Escape Resort can arrange meals for your guests, lodging for out‐of‐town attendees, and help coordinate décor and other event logistics to make your destination wedding smooth and memorable."
  },
  {
    question: "How do we book Woodland Escape Resort for a destination wedding near Washim?",
    answer: "You can contact the resort via phone or WhatsApp to their reservations team, visit their official website, or schedule a site visit. It’s recommended to book well in advance to secure your preferred wedding date."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patil, Washim",
    text: "Our destination wedding at Woodland Escape Resort was magical! The greenery, guest comfort, and seamless arrangements made our big day unforgettable. Highly recommended near Washim!"
  },
  {
    name: "Ms. Sneha & Mr. Rajesh, Washim",
    text: "Choosing Woodland Escape Resort for our wedding was the best decision — the setting was beautiful, the staff were responsive, and our guests loved their stay. A perfect wedding destination near Washim!"
  }
];






























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Near Washim",
  "image": "https://woodlandescape.com/assets/images/washim-wedding-resort.jpg",
  "description": "Celebrate your dream destination wedding at Woodlandescape Resort near Washim. Perfect for luxury weddings, outdoor ceremonies, pre-wedding shoots, riverside and hilltop celebrations, and family-friendly events.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "36"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "49999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/destination-wedding-washim"
  }
};




  return (
    <div>
<Helmet>
  <title>Destination Wedding Near Washim | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Host your dream destination wedding at Woodlandescape Resort near Washim. Luxury weddings, outdoor ceremonies, pre-wedding shoots, riverside and hilltop venues for an unforgettable celebration." 
  />
  <meta 
    name="keywords" 
    content="Destination Wedding Near Washim, Washim Wedding Venue, Washim Luxury Wedding Location, Affordable Wedding Spot Washim, Washim Pre Wedding Shoot Location, Washim Outdoor Wedding Spot, Washim Riverside Wedding Venue, Washim Hill Wedding Location, Washim Family Wedding Resort, Washim Resort Wedding Packages, Washim Wedding Booking Online, Washim Wedding Hall, Washim Marriage Destination, Washim Resort for Wedding, Washim Wedding Destination Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/43.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Destinationweddingnearwashim;